import React from "react";
import { Database } from "lucide-react";
import SearchableSelect from "modules/swiftboard/components/ui/SearchableSelect";
import Chip from "../../../components/Chip";
import LifecycleBadge from "../../../components/LifecycleBadge";
import { SOURCE_STATUS, SUBJECT_TYPE_LABEL } from "../../../features/builder.constants";
import { roleHolders } from "../features/source-field.utils";

function RoleChip({ label, keys, missing }) {
  if (keys.length) return <Chip tone={keys.length > 1 ? "danger" : "brand"}>{`${label}: ${keys.join(", ")}`}</Chip>;
  return missing ? <Chip tone="warning">{`No ${label.toUpperCase()} field`}</Chip> : null;
}

// Source picker and what the chosen source has: lifecycle, subject, and which fields hold the single roles.
export default function SourceSummary({ sources, sourcesLoading, sourceId, onChoose, source, locked }) {
  const options = sources.map((item) => ({ value: item.id, label: `${item.label} (${item.source_key}) · ${SOURCE_STATUS[item.status]?.label ?? item.status}` }));
  const holders = roleHolders(source?.fields);

  return (
    <div className="rounded-lg border border-border bg-surface p-3">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
        <div className="w-full lg:w-96">
          <SearchableSelect options={options} value={sourceId ?? ""} onChange={(value) => onChoose(value ? Number(value) : null)} placeholder="Choose a source" isLoading={sourcesLoading} isDisabled={locked} />
          {locked && <p className="mt-1 text-[11px] text-text_muted">Save or discard your changes to switch sources.</p>}
        </div>
        {source && (
          <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 text-xs text-text_secondary">
              <Database size={14} className="text-primary" />
              <span className="font-mono">{source.root_model}</span>
            </span>
            <LifecycleBadge status={source.status} version={source.version_no} />
            <Chip>{`Subject: ${SUBJECT_TYPE_LABEL[source.subject_type] ?? source.subject_type}`}</Chip>
            <Chip>{`${source.fields?.length ?? 0} fields`}</Chip>
            <RoleChip label="Subject" keys={holders.SUBJECT} missing={source.subject_type !== "NONE"} />
            <RoleChip label="Reference" keys={holders.REFERENCE} missing />
            <RoleChip label="Project ref" keys={holders.PROJECT_REF} missing={false} />
          </div>
        )}
      </div>
    </div>
  );
}
